import { render, staticRenderFns } from "./TruewalletAuto.vue?vue&type=template&id=3848b3fe&scoped=true&"
import script from "./TruewalletAuto.vue?vue&type=script&lang=js&"
export * from "./TruewalletAuto.vue?vue&type=script&lang=js&"
import style0 from "./TruewalletAuto.vue?vue&type=style&index=0&id=3848b3fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848b3fe",
  null
  
)

export default component.exports